var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.309,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    className: "cls-1",
    d: "M0 0h19.309v12H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    style: {
      clipPath: "url(#clip-path1)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-1",
    d: "M11.383 9.014a.549.549 0 0 0-.063-.214L6.819.307a.587.587 0 0 0-.7-.276.57.57 0 0 0-.383.644l1.754 9.42a.556.556 0 0 0 .082.2 1.966 1.966 0 0 0 .065.241 2.047 2.047 0 0 0 2.584 1.241 2.006 2.006 0 0 0 1.166-1.012 1.943 1.943 0 0 0 0-1.752M9.557.648a.57.57 0 1 0 0 1.141 8.332 8.332 0 0 1 8.395 8.248.581.581 0 0 0 1.162 0A9.485 9.485 0 0 0 9.557.648M3.551 2.732A9.293 9.293 0 0 0 0 10.037a.576.576 0 0 0 .581.571.576.576 0 0 0 .582-.571A8.165 8.165 0 0 1 4.282 3.62a.563.563 0 0 0 .088-.8.59.59 0 0 0-.818-.085"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.4ed9be15b4143cb83155e15fe604238a.svg";
export { ForwardRef as ReactComponent };